import { provideEffects } from '@ngrx/effects';
import { CategoryRestrictionProfilePresetConfigurationEffects } from './category-restriction-profile-preset-configuration.effects';

export const provideCategoryRestrictionProfilePresetConfigurationStore = () => [
  provideEffects([CategoryRestrictionProfilePresetConfigurationEffects]),
];
